import './MenuOption.scss'
import { useLocation, useNavigate } from "react-router-dom";
import arrowDown from '../../../assets/icons/sideMenu/arrow.svg'
import { useEffect, useState } from 'react';
import { useMenu } from '../../../context/MenuContext';

const MenuOption = ({ menuData, index }) => {

    const location = useLocation()
    const navigate = useNavigate()

    const rute = location.pathname.split("/")[1]
    const subrute = location.pathname.split("/")[2]
    const routejson = menuData.url.split("/")[1]


    const { menuData: menuList } = useMenu();

    //cambia de estado la opcion si open del json del menu a !isOpen cada que se preciona
    const [mostrarSubMenu, setMostrarSubMenu] = useState()
    const showSubMenu = () => {
        setMostrarSubMenu(!mostrarSubMenu)
    }
    useEffect(() => {
        if (!menuList.length) return;
        let rutaEncontrada = false;
        menuList.forEach((item, key) => {
            if (index == key) {
                item.subMenu.forEach((itemSub) => {
                    if (location.pathname === itemSub.url) {
                        rutaEncontrada = true;
                    }
                });
            }
        });
        setMostrarSubMenu(rutaEncontrada);
    }, [rute, menuList]);


    return (
        <>
            {/* optcion del menu principal */}
            <div onClick={showSubMenu} id={"orageBorder"}
                className={`${mostrarSubMenu && !menuData.isOpen ? "noSeleccionado" : ""}  ${rute == routejson ? menuData.isOpen ? "orangeBackgroundRounded" : "orangeBackground" : "containerOptionMenu"}`}>
                <div className="container-menu-content">
                    <div className="optionMenuIcon" style={{ filter: "invert(0)" }}>
                        <img width={"20px"} src={require(`../../../assets/icons/sideMenu/${menuData.icon}`)}></img>
                    </div>
                    <div className="optionMenuTitle"
                    // onClick={() => { navigate(menuData.url) }}
                    >{menuData.title}</div>
                </div>
                {
                    !mostrarSubMenu ?
                        <div className="optionMenuArrow" onClick={showSubMenu}>
                            <img src={arrowDown} alt="optionMenuArrow" />
                        </div> :
                        <div className="optionMenuArrow" onClick={showSubMenu}>
                            <img src={arrowDown} className="upArrow" alt="optionMenuArrow" />
                        </div>

                }

            </div>
            {/* opcion del menu secundario */}
            {/* con esto : subrute == item.url.split("/")[2] comparamos
             si la url del navegador coincide con la url del json si es asi
            pinta de color anaranjado el texto si no lo deja igual */}
            <div className="showSubMenuTransicion">
                {
                    mostrarSubMenu ?
                        menuData.subMenu.map((item, key) => {

                            return (
                                <div
                                    key={item.title}
                                    className={`${"containerOptionsubMenu"} ${subrute == item.url.split("/")[2] ? "selectedSub" : ""} `}
                                    onClick={() => {
                                        navigate(item.url)
                                    }}>
                                    <div className={`optionMenuIcon `}><img width={17}
                                        src={require(`../../../assets/icons/sideMenu/${item.icon}`)}></img>
                                    </div>
                                    <div className={`optionMenuTitle `}>{item.title}</div>
                                </div>
                            )
                        })

                        :
                        null
                }
            </div>

        </>
    )
}
export default MenuOption